import React from 'react';
import { Box, Typography } from '@mui/material';

interface MessageProps {
  message: any;
}

const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};


const FlowMessage: React.FC<MessageProps> = ({ message }) => {
  try {
    const content = message?.content || {};
    const text = content?.text || 'No content available';

    return (
      <Box>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: formatText(text) }}
>
          {/* {text} */}
        </Typography>
      </Box>
    );
  } catch (error) {
    return <Typography color="error">Error displaying flow message</Typography>;
  }
};

export default FlowMessage;
